import React from 'react';
import ServiceCard from './ServiceCard';

interface ServicesData {
  orderUuid: string;
  description: string;
  foodCategory: string;
  foodName: string;
  orderQuantity: number | null;
  price: number | null;
  orderCreatedAt: string;
}
interface IProps {
  services: ServicesData[];
  selectedServiceInfo: any;
  setSelectedServiceInfo: any;
}

const ListOfServices = (props: IProps) => {
  const { services, selectedServiceInfo, setSelectedServiceInfo } = props;
  return (
    <div className="flex flex-col gap-2.5 xl:overflow-y-auto p-2 md:pr-2.5">
      {services.map((info: ServicesData, index) => (
        <ServiceCard
          info={info}
          selectedServiceInfo={selectedServiceInfo}
          setSelectedServiceInfo={setSelectedServiceInfo}
          key={index}
        />
      ))}
    </div>
  );
};

export default ListOfServices;
